import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { collection, addDoc, Timestamp, getDocs, query } from 'firebase/firestore';
import {
  Container,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Snackbar,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

function AnnouncementForm() {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    isForAllStudents: true,
    selectedCourse: '',
  });
  const [courses, setCourses] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const navigate = useNavigate();

  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(u => setUser(u));
    return unsubscribe;
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      const coursesQuery = query(collection(db, 'dance_courses'));
      const snapshot = await getDocs(coursesQuery);
      const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCourses(list);
    };

    fetchCourses();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleCourseChange = (e) => {
    setFormData(prev => ({ ...prev, selectedCourse: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      setSnackbar({ open: true, message: "Vous devez être connecté", severity: "error" });
      return;
    }

    const data = {
      title: formData.title,
      description: formData.description,
      authorId: user.uid,
      author: user.displayName || 'Anonyme',
      date: Timestamp.now(),
      likesCount: 0,
      commentsCount: 0,
      isForAllStudents: formData.isForAllStudents,
      selectedCourse: formData.selectedCourse,
    };

    try {
      await addDoc(collection(db, 'announcements'), data);
      setSnackbar({ open: true, message: "Annonce créée avec succès", severity: "success" });
      setTimeout(() => navigate('/announcements'), 1500);
    } catch (error) {
      console.error("Erreur création :", error);
      setSnackbar({ open: true, message: "Erreur lors de la création", severity: "error" });
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Nouvelle Annonce</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          name="title"
          label="Titre"
          fullWidth
          margin="normal"
          value={formData.title}
          onChange={handleChange}
          required
        />
        <TextField
          name="description"
          label="Description"
          fullWidth
          margin="normal"
          multiline
          rows={5}
          value={formData.description}
          onChange={handleChange}
          required
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.isForAllStudents}
              onChange={handleChange}
              name="isForAllStudents"
            />
          }
          label="Pour tous les élèves"
        />
        {!formData.isForAllStudents && (
          <FormControl fullWidth margin="normal">
            <InputLabel>Cours</InputLabel>
            <Select
              value={formData.selectedCourse}
              onChange={handleCourseChange}
              label="Cours"
              required
            >
              {courses.map((course) => (
                <MenuItem key={course.id} value={course.id}>
                  {course.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Button variant="contained" type="submit" sx={{ mt: 2 }}>Créer</Button>
      </form>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Container>
  );
}

export default AnnouncementForm;